import type { InertiaLinkProps } from '@inertiajs/vue3';
import { clsx } from 'clsx';
import type { ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export function toUrl(href: NonNullable<InertiaLinkProps['href']>) {
    return typeof href === 'string' ? href : href?.url;
}

/**
 * Utilitaires de couleurs pour le theming
 */

/**
 * Mappe les couleurs hardcoded vers les tokens sémantiques
 */
export const COLOR_MAPPINGS = {
    // Mode clair
    '#FDFDFC': 'background',
    '#ffffff': 'card',
    '#1b1b18': 'foreground',
    '#EDEDEC': 'foreground',
    '#706f6c': 'muted-foreground',
    '#A1A09A': 'muted-foreground',
    '#e3e3e0': 'border',
    '#dbdbd7': 'muted',

    // Mode sombre
    '#0a0a0a': 'background',
    '#161615': 'card',
    '#3E3E3A': 'border',
    '#62605b': 'border',
} as const;

/**
 * Suggère un token sémantique pour une couleur hardcoded
 */
export function suggestColorToken(hardcodedColor: string): string | null {
    return (
        COLOR_MAPPINGS[hardcodedColor as keyof typeof COLOR_MAPPINGS] || null
    );
}
